export const CONNECT_REQUEST = 'CONNECT_REQUEST';
export const CONNECT_SUCCESS = 'CONNECT_SUCCESS';
export const CONNECT_FAILURE = 'CONNECT_FAILURE';

export const GET_CONNECTIONS_REQUEST = 'GET_CONNECTIONS_REQUEST';
export const GET_CONNECTIONS_SUCCESS = 'GET_CONNECTIONS_SUCCESS';
export const GET_CONNECTIONS_FAILURE = 'GET_CONNECTIONS_FAILURE';
